import React, { useEffect, useState } from 'react';
import Homepage from './components/homePage';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import RegisterPage from './components/registerpage';
import Survey from './components/survey';
import AdminRoute from './components/AdminRoute';
import Footer from './components/footer';
import Navbar2 from './components/navbar2';
import './App.css';
import { useDispatch } from 'react-redux';
import { fetchBlastOffRuleResult } from './actions';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import PasswordReset from './components/PasswordReset';
import ForgotPassword from './components/ForgotPassword';

const LoginSignUpRoute = React.lazy(() => import('./components/login'));

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation(); // ✅ Track current route
  const loginType = localStorage.getItem("loginType");

  // Fetch initial data
  useEffect(() => {
    dispatch(fetchBlastOffRuleResult());
  }, [dispatch]);

  // Check login state on mount
  useEffect(() => {
    const token = localStorage.getItem("userInfo");
    setIsLoggedIn(!!token);
  }, []);

  // Update login state if MSAL authentication changes
  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      localStorage.setItem("userInfo", JSON.stringify(accounts[0]));
      localStorage.setItem("loginType", "microsoft");
      setIsLoggedIn(true);
    }
  }, [isAuthenticated, accounts]);

  return (
    <div className="App">
      <Navbar2 />
      <main className="main-content">
        <Routes>
          {/* Redirect root to home */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* Public routes */}
          <Route path="/home" element={<Homepage />} />
          <Route path="/registerpage" element={<RegisterPage />} />
          <Route path="/survey/:id?" element={<Survey />} />
          <Route path="/passwordReset" element={<PasswordReset />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />

          {/* Admin route */}
          <Route path="/admin" element={<AdminRoute />} />

          {/* Login route with guard */}
          <Route
            path="/login"
            element={
              isLoggedIn && loginType == 'normal' ? (
                <Navigate to="/home" replace />
              ) : (
                <React.Suspense fallback={<div>Loading...</div>}>
                  <LoginSignUpRoute setIsLoggedIn={setIsLoggedIn} />
                </React.Suspense>
              )
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;